import Vue from "vue";
import Vuex from "vuex";
import createCache from "vuex-cache";
import createPersistedState from 'vuex-persistedstate';
import notification from "./notification";
import { getBrowserLocale } from "@/utils/locale";
import { getDictionaryItems, getReportsType, getUserLocations } from "@/services/api"
import dictionaries from "./dictionaries";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    apiPath: localStorage[`${document.location.pathname}-API`],
    wsPath: localStorage[`${document.location.pathname}-WS`],
    token: localStorage[`${document.location.pathname}-TOKEN`],
    user: localStorage[`${document.location.pathname}-USER`]
      ? JSON.parse(localStorage[`${document.location.pathname}-USER`]) : {},
    isCloudMode: localStorage[`${document.location.pathname}-CLOUD`]
      ? JSON.parse(localStorage[`${document.location.pathname}-CLOUD`]) : false,
    version: null,
    breadcrumb: [],
    appContainerSize: { width : window.innerWidth || 800, height : window.innerHeight || 800 },
    layoutBody: { width : 800, height : 800 },
    gridsStates: {},
    deviceCardInfPeriod: null,
    deviceAvailabilityFilter: null,
    deviceAvailabilityGridFilter: null,
    deviceCountersFilter: null,
    deviceCountersGridFilter: null,
    partReplacementsFilter: null,
    installedСonsumablesFilter: null,
    partReplacementsGridFilter: null,
    gridDevices: window.localStorage.gridDevices
      ? JSON.parse(window.localStorage.gridDevices): null,
    gridDashboardDevices: window.localStorage.gridDashboardDevices
      ? JSON.parse(window.localStorage.gridDashboardDevices): null,
    gridDashboardDevicesToolbar: null,
    gridStateMaterial: null,
    gridStatePurchase: {
      filterValue: [ "docDate", ">=", new Date(new Date().getFullYear(), 0, 1) ]
    },
    gridStateAssemblyExports: null,
    gridStateTransactions: null,
    gridStateRequirement: {
      sort: [{ selector: "createDatetime", desc: true }]
    },
    gridStateSales: null,
    gridStateOutsourceIn: null,
    gridStateOutsourceOut: null,
    gridStateComplectations: null,
    browserLocale: getBrowserLocale(),
    gridStateDeviceUserDays: null,
    gridStateAgentLogs: null,
    defalutLicense: null,
    userLicensesRelevant: null,
    locations: null,
    defaultLocation: null
  },
  mutations: {
    setApiPath(state, path) {
      state.apiPath = path;
      localStorage[`${document.location.pathname}-API`] = path;
    },
    setWsPath(state, path) {
      state.wsPath = path;
      localStorage[`${document.location.pathname}-WS`] = path;
    },
    setToken(state, token) {
      state.token = token;
      localStorage[`${document.location.pathname}-TOKEN`] = token;
    },
    setUser(state, user) {
      state.user = user;
      localStorage[`${document.location.pathname}-USER`] = JSON.stringify(user);
    },
    setIsCloudMode(state, isCloudMode) {
      state.isCloudMode = isCloudMode;
      localStorage[`${document.location.pathname}-CLOUD`] = isCloudMode;
    },
    setVersion(state, version) {
      state.version = version;
    },
    setAppContainerSize(state, appContainerSize) {
      state.appContainerSize = appContainerSize;
    },
    setLayoutBody(state, layoutBody) {
      state.layoutBody = layoutBody;
    },
    setBreadcrumb(state, breadcrumb) {
      state.breadcrumb = breadcrumb;
    },
    setGridsStates(state, gridState) {
      state.gridsStates[gridState.key] = gridState.state;
    },
    setDeviceCardInfPeriod(state, deviceCardInfPeriod) {
      state.deviceCardInfPeriod = deviceCardInfPeriod;
    },
    setDeviceAvailabilityFilter(state, deviceAvailabilityFilter) {
      state.deviceAvailabilityFilter = deviceAvailabilityFilter;
    },
    setDeviceAvailabilityGridFilter(state, deviceAvailabilityGridFilter) {
      state.deviceAvailabilityGridFilter = deviceAvailabilityGridFilter;
    },
    setDeviceCountersFilter(state, deviceCountersFilter) {
      state.deviceCountersFilter = deviceCountersFilter;
    },
    setDeviceCountersGridFilter(state, deviceCountersGridFilter) {
      state.deviceCountersGridFilter = deviceCountersGridFilter;
    },
    setPartReplacementsFilter(state, partReplacementsFilter) {
      state.partReplacementsFilter = partReplacementsFilter;
    },
    setInstalledСonsumablesFilter(state, installedСonsumablesFilter) {
      state.installedСonsumablesFilter = installedСonsumablesFilter;
    },
    setPartReplacementsGridFilter(state, partReplacementsGridFilter) {
      state.partReplacementsGridFilter = partReplacementsGridFilter;
    },
    setGridStateMaterial(state, gridState) {
      state.gridStateMaterial = gridState;
    },
    setGridStatePurchase(state, gridState) {
      state.gridStatePurchase = gridState;
    },
    setGridStateAssemblyExports(state, gridStateAssemblyExports) {
      state.gridStateAssemblyExports = gridStateAssemblyExports;
    },
    setGridStateTransactions(state, gridState) {
      state.gridStateTransactions = gridState;
    },
    setGridStateRequirement(state, gridState) {
      state.gridStateRequirement = gridState;
    },
    setGridStateSales(state, gridState) {
      state.gridStateSales = gridState;
    },
    setGridStateOutsourceIn(state, gridState) {
      state.gridStateOutsourceIn = gridState;
    },
    setGridStateOutsourceOut(state, gridState) {
      state.gridStateOutsourceOut = gridState;
    },
    setGridStateComplectations(state, gridState) {
      state.gridStateComplectations = gridState;
    },
    setGridDevices(state, gridDevices) {
      state.gridDevices = gridDevices;
      window.localStorage.gridDevices = JSON.stringify(gridDevices);
    },
    setGridDashboardDevices(state, gridDashboardDevices) {
      state.gridDashboardDevices = gridDashboardDevices;
      window.localStorage.gridDashboardDevices = JSON.stringify(gridDashboardDevices);
    },
    setGridDashboardDevicesToolbar(state, gridDashboardDevicesToolbar) {
      state.gridDashboardDevicesToolbar = gridDashboardDevicesToolbar;
    },
    setGridStateDeviceUserDays(state, gridState) {
      state.gridStateDeviceUserDays = gridState;
    },
    setGridStateAgentLogs(state, gridState) {
      state.gridStateAgentLogs = gridState;
    },
    setDefalutLicense(state, license) {
      state.defalutLicense = license;
    },
    setUserLicensesRelevant(state, license) {
      state.userLicensesRelevant = license;
    },
    setDefaultLocation(state, defaultLocation) {
      state.defaultLocation = defaultLocation;
    },
    setLocations(state, updatesetLocations) {
      state.locations = updatesetLocations;
    },
  },
  actions: {
    getDictionaryItems: async (ctx, code) => (await getDictionaryItems(code)).pageRows,
    getReportsType: async () => await getReportsType(),
    async setLocations({ commit }) {
      const result = await getUserLocations();
      commit('setLocations', result);
    },
  },
  modules: { dictionaries, notification },
  getters: {
    apiPath(state) {
      return state.apiPath;
    },
    wsPath(state) {
      return state.wsPath;
    },
    token(state) {
      return state.token;
    },
    user(state) {
      return state.user;
    },
    appContainerSize(state) {
      return state.appContainerSize;
    },
    layoutBody(state) {
      return state.layoutBody;
    },
    breadcrumb(state) {
      return state.breadcrumb;
    },
    gridsStates(state) {
      return state.gridsStates;
    },
    getGridState: (state) => (code) => {
      const gridsStates = state.gridsStates;
      const gridName = Object.keys(gridsStates).find((grid) => grid === code);

      return gridsStates[gridName];
    },
    deviceCardInfPeriod(state) {
      return state.deviceCardInfPeriod;
    },
    deviceAvailabilityFilter(state) {
      return state.deviceAvailabilityFilter;
    },
    deviceAvailabilityGridFilter(state) {
      return state.deviceAvailabilityGridFilter;
    },
    deviceCountersFilter(state) {
      return state.deviceCountersFilter;
    },
    deviceCountersGridFilter(state) {
      return state.deviceCountersGridFilter;
    },
    partReplacementsFilter(state) {
      return state.partReplacementsFilter;
    },
    installedСonsumablesFilter(state) {
      return state.installedСonsumablesFilter;
    },
    partReplacementsGridFilter(state) {
      return state.partReplacementsGridFilter;
    },
    gridStateMaterial(state) {
      return state.gridStateMaterial;
    },
    gridStatePurchase(state) {
      return state.gridStatePurchase;
    },
    gridStateAssemblyExports(state) {
      return state.gridStateAssemblyExports;
    },
    gridStateTransactions(state) {
      return state.gridStateTransactions;
    },
    gridStateRequirement(state) {
      return state.gridStateRequirement;
    },
    gridStateSales(state) {
      return state.gridStateSales;
    },
    gridStateOutsourceIn(state) {
      return state.gridStateOutsourceIn;
    },
    gridStateOutsourceOut(state) {
      return state.gridStateOutsourceOut;
    },
    gridStateComplectations(state) {
      return state.gridStateComplectations;
    },
    gridDevices(state) {
      return state.gridDevices;
    },
    gridDashboardDevices(state) {
      return state.gridDashboardDevices;
    },
    browserLocale(state) {
      return state.browserLocale;
    },
    gridDashboardDevicesToolbar(state) {
      return state.gridDashboardDevicesToolbar;
    },
    gridStateDeviceUserDays(state) {
      return state.gridStateDeviceUserDays;
    },
    gridStateAgentLogs(state) {
      return state.gridStateAgentLogs;
    },
    defalutLicense(state) {
      return state.defalutLicense;
    },
    userLicensesRelevant(state) {
      return state.userLicensesRelevant;
    },
    isCloudMode(state) {
      return state.isCloudMode;
    },
    version(state) {
      return state.version;
    },
    defaultLocation(state) {
      return state.defaultLocation;
    },
    getLocations(state) {
      return state.locations;
    },
  },
  plugins: [createCache(), createPersistedState({
    paths: [
      'deviceAvailabilityFilter', 'deviceCountersFilter', 'partReplacementsFilter', 'installedСonsumablesFilter',
      'gridsStates', 'deviceCardInfPeriod', 'gridDashboardDevicesToolbar'
    ]
  })]
});
